{
  "projectId": "gen-lang-client-0163222437",
  "appId": "1:110886016178:web:615362c6c77d59498a65ab",
  "apiKey": "AIzaSyBOFMgZ4KgaQhL3PVLYP2daB2xAuJjlELM",
  "authDomain": "gen-lang-client-0163222437.firebaseapp.com",
  "firestoreDatabaseId": "ai-studio-7a0036f0-ca9c-424b-a7b6-da182aa8a358",
  "storageBucket": "gen-lang-client-0163222437.firebasestorage.app",
  "messagingSenderId": "110886016178",
  "measurementId": ""
}